import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  MojaFirmaClient,
  SubscriptionPackage,
  UpdatePracenjeLageraZaEOtpremniceCommand,
} from '@kodit/core/data-api';
import { AlertService, AuthService } from '@kodit/core/services';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kodit-moja-firma-eotpremnice-podesavanja',
  templateUrl: './moja-firma-eotpremnice-podesavanja.component.html',
  styleUrls: ['./moja-firma-eotpremnice-podesavanja.component.scss'],
})
export class MojaFirmaEOtpremnicePodesavanjaComponent
  implements OnInit, OnDestroy {
  private _subs: Subscription = new Subscription();

  pracenjeLageraCtrl = new FormControl(true);
  hasVeleprodaja: boolean;

  constructor(
    private _client: MojaFirmaClient,
    private _alertService: AlertService,
    private _authService: AuthService
  ) {}

  ngOnInit(): void {
    this.hasVeleprodaja = this._authService.hasPackage(
      SubscriptionPackage[SubscriptionPackage.VELEPRODAJA]
    );

    if (this.hasVeleprodaja) {
      this.pracenjeLageraCtrl.disable({ emitEvent: false });
      return;
    }

    this._subs.add(
      this._client.getKonfiguracija().subscribe((res) => {
        this.pracenjeLageraCtrl.patchValue(
          res.data.pracenjeLageraZaEOtpremnice,
          { emitEvent: false }
        );
      })
    );
  }

  onPracenjeLageraChange(value: boolean) {
    this._subs.add(
      this._client
        .updatePracenjeLageraZaEOtpremnice(
          new UpdatePracenjeLageraZaEOtpremniceCommand({
            pracenjeLageraZaEOtpremnice: value,
          })
        )
        .subscribe({
          next: (res) => {
            this._alertService.addSuccessMsg(res.messages[0]);
            this._authService.notifyPackagesChanged();
          },
          error: () => {
            this.pracenjeLageraCtrl.patchValue(!value, { emitEvent: false });
          },
        })
    );
  }

  ngOnDestroy(): void {
    this._subs.unsubscribe();
  }
}
